import { render, staticRenderFns } from "./addAndModify.vue?vue&type=template&id=571b59f8&"
import script from "./addAndModify.vue?vue&type=script&lang=js&"
export * from "./addAndModify.vue?vue&type=script&lang=js&"
import style0 from "./addAndModify.vue?vue&type=style&index=0&id=571b59f8&prod&lang=less&rel=stylesheet%2Fless&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports